import { useCallback, useRef, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "../../Network/API";
import Paginate from "../../CustomHook/Paginate";
import SiteFilterModel from "../../Models/SiteFilterModel";
import { RMS_STATION_FETCH_LOAD_MORE, RMS_STATION_FETCH_START, RMS_STATION_FETCH_SUCCESS } from "../../Reducer/RmsStationSlice";
import { RMS_ALARM_GROUP_FETCH_SUCCESS } from "../../Reducer/RmsAlarmGroupSlice";
import { Link } from "react-router-dom";
import Agent from "../../Network/Agent";
import Env from "../../CustomHook/Env";
import { toast } from "react-hot-toast";


export default function RmsStation() {
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const [modalDialog, setModalDialog] = useState(false);
    const [page, setPage] = useState(1);
    const [siteId, setSiteId] = useState('');
    const [exporting, setExporting] = useState(false);
    const selector = useSelector((state) => state.RmsStationReducer);

    useEffect(() => {
       Agent.All_RMS.rms_nav(dispatch)
       Agent.All_RMS.all(dispatch)
       all_door()
    }, []);

    useEffect(() => {

        if(page!=1){
            dispatch(RMS_STATION_FETCH_START())
            Agent.All_RMS.load_more(dispatch,page)
        }
       
    }, [page]);

    
    const searchSite = (site_code) => {
        setSiteId(site_code);
        API.get('/v1/oauth/rms_station?site_id=' + site_code).then((response) => {
            setPage(1)
            dispatch(RMS_STATION_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
    
        });
    }


    const syncData = () => {
        setPage(1)
        const loaderElement = document.querySelector(".loading-mask");
        loaderElement.removeAttribute('hidden');
        loaderElement.setAttribute('visible', 'true');
        API.get('/v1/oauth/rms_station').then((response) => {
            if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                loaderElement.setAttribute('hidden', 'true');
            }
            dispatch(RMS_STATION_FETCH_SUCCESS(response.data.data))
        }).catch((error) => {
            if (loaderElement && !loaderElement.hasAttribute('hidden')) {
                loaderElement.setAttribute('hidden', 'true');
            }
        });
    }


    const all_door = () => {
       
        setPage(1)

    }

    const exportCsv = () => {
        if (exporting) return;
        setExporting(true);
        const toastId = toast.loading("Exporting CSV...");
        Agent.All_RMS.export({ site_id: siteId })
            .then((response) => {
                const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "rms_stations.csv");
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                toast.success("CSV downloaded", { id: toastId });
            })
            .catch(() => toast.error("Export failed", { id: toastId }))
            .finally(() => setExporting(false));
    };

    const observer = useRef();
    const lastElementRef = useCallback((element) => { 
        //element is the react element being referenced
        
        // disconnect observer set on previous last element
        if (observer.current) observer.current.disconnect();
          
        // if there's no more data to be fetched, don't set new observer
        if (!selector?.data.has_more_page) return;
          
        // set new observer
        observer.current = new IntersectionObserver((entries) => {
          // increase page number when element enters (is intersecting with) viewport.
          // This triggers the pagination hook to fetch more items in the new page
          if (entries[0].isIntersecting && selector?.data.has_more_page) setPage((prev) => prev + 1);
        });
      
        // observe/monitor last element
        if (element) observer.current.observe(element);
      }, [selector?.data.has_more_page]);


    
    const selector_rms_alarm_nav = useSelector((state) => state.rmsAlarmGroupReducer)
   
    const strAscending = selector?.sites.length > 0 && [...selector?.sites].sort((a, b) =>
        a.site_id > b.site_id ? 1 : -1,
    );

    return (
        <>

            <div className="mb-2 me-1 ms-1">
                <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mt-2">
                    <div className="input-group input-group-sm max-with-searbar">
                        <input type="text" onChange={(e) => searchSite(e.target.value)} className="form-control" placeholder="search by site id...." />
                        <button className="btn btn-success" type="button"><i className="fa-light fa-search" /></button>
                        <button className="btn btn-info" type="button" onClick={() => setModalDialog(!modalDialog)}><i className="fa-duotone fa-filter-list me-1" />Filter</button>
                    </div>
                    <button className="btn btn-warning btn-sm flex-shrink-0" type="button" onClick={() => syncData()}>
                        <i className="fa-light fa-refresh me-1" />Sync
                    </button>
                    <button className="btn btn-success btn-sm flex-shrink-0" type="button" onClick={exportCsv} disabled={exporting}>
                        <i className={`fa-light ${exporting ? "fa-spinner fa-spin" : "fa-file-export"} me-1`} />
                        {exporting ? "Exporting..." : "Export CSV"}
                    </button>


                    <div class="dropdown custom-dropdown-grop-btn ms-2">
                        <button class="btn btn-outline-primary bg-white text-dark dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="fa-duotone fa-bell"></i> RMS Event ({selector_rms_alarm_nav?.data?.total_alarm > 0 ? <span className="badge bg-danger">{selector_rms_alarm_nav?.data?.total_alarm}</span> : 0})
                        </button>
                        <ul class="dropdown-menu">
                            {!selector_rms_alarm_nav?.loading && selector_rms_alarm_nav?.data?.rms_alarm_group?.map((rms_alarm, index) => (
                                <>
                                    <li className="ps-1 list-header">{rms_alarm.name}</li>
                                    <li><hr className="dropdown-divider" /></li>

                                    {rms_alarm?.alarm?.map((alarm, index) => (
                                        <li>
                                            <Link className="dropdown-item d-flex gap-2 align-items-center justify-content-between" to={`/rms_alarm_filter/${alarm.order_list}/fatch`}>
                                                {alarm.name}
                                                <div className="form-check form-switch mb-0">
                                                    {alarm.active_alarm_count > 0 ? <span className="badge bg-danger">{alarm.active_alarm_count}</span> : <span className="badge bg-dark">0</span>}
                                                </div>
                                            </Link>
                                        </li>
                                    ))}


                                </>
                            ))}
                        </ul>
                    </div>



                </div>

            </div>

            <div className="">
         
                <div className="table-responsive scrol-table-height" >
                   
                        <table className="table  table-bordered bg-white table-striped m-0 text-center">
                            <thead className="text-uppercase">
                                <tr>
                                    <th className=" w-150">Last Updated</th>
                              
                                    <th className="text-center " >Site ID</th>
                                    <th className="text-center " >{Env.CUSTOMER_SITE} Site ID</th>
                                   
                               
                                    <th className="text-center " >Network</th>

                                    <th className="text-center  w-50">Door Open</th>
                                    <th className="text-center  w-50">Mains Fail</th>
                                    <th className="text-center  w-50" >DC Low</th>

                                    <th className="text-center  w-50" >Module Fault</th>
                                    <th className="text-center  w-50">LLVD</th>
                                    <th className="text-center  w-50">PG ON</th>
                                    <th className="text-center  w-50">MDB Fault</th>
                                    <th className="text-center  w-50">ODC TEMP</th>
                                    <th className="text-center  w-50">FAN FAULT</th>
                                    <th className="text-center  w-50">SMOKE</th>
                                    <th className="text-center  w-50">WATER LEAKAGE</th>
                                    <th className="text-center  w-50">AVIATION LIGHT</th>
                                    <th className="text-center  w-50">FUSE FAULT</th>
                                    <th className="text-center  w-50">PHASE FAULT</th>
                                    <th className="text-center  w-50">PHASE MISSING(R)</th>
                                    <th className="text-center  w-50">PHASE MISSING(Y)</th>
                                    <th className="text-center  w-50">PHASE MISSING(B)</th>
                                    <th className="text-center  w-50">Overload</th>
                                    <th className="text-center  w-50">Site Down</th>

                                </tr>
                            </thead>
                            <tbody>
                                {!selector?.main_loading && selector?.sites.length > 0 && strAscending?.map((site, index) => (
                                    <tr className={`${site.device_live_status == 0 ? 'offline-tr' : ''}`}   ref={index === selector?.sites.length - 1 ? lastElementRef : undefined}>
                                        <td className="">
                                            <p className="m-0 p-0" style={{ fontSize: '12px', width: '150px' }}>{site.update_time}</p>

                                        </td>
                                      
                                        <td className="text-center">
                                            <Link className="fw-bold" to={`/site/${site.site_id}`}>{site.site_id}</Link>
                                        </td>
                                        <td className="text-center">
                                            <Link className="fw-bold" to={`/site/${site.site_id}`}>{site.customer_site_id}</Link>
                                        </td>
                                      
                                    
                                        <td className="text-center">
                                            {site.device_live_status === 1 ?
                                                <div className="signal-bars mt1 sizing-box good four-bars">
                                                    <span>
                                                        <img src="/assets/icon/6.svg" className="tower-height" alt="" />
                                                    </span>
                                                    <div className={`first-bar bar ${site.network_val >= 1 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`second-bar bar ${site.network_val >= 2 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`third-bar bar ${site.network_val >= 3 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`fourth-bar bar ${site.network_val >= 4 ? '' : 'null-color'}`}>
                                                    </div>
                                                    <div className={`fifth-bar bar ${site.network_val >= 5 ? '' : 'null-color'}`}>
                                                    </div>
                                                </div>
                                                :
                                                <i class="fa-solid fa-wifi-slash offline-rms-icon" title="Site not updating" />
                                            }
                                        </td>

                                        <td>
                                            {site?.conf_door_open == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.door_open == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.mains_fail == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.dc_low == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
              
                                        <td>
                                            {site?.conf_rectifier_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.rectifier_fault == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_llvd == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.llvd == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_pg_status == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.pg_status == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.mdb_fault == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_odc_temp_high == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.odc_temp_high == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_dc_fan_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.dc_fan_fault == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_smoke == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.smoke == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_water_leakage == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.water_leakage == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_aviation_light_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.aviation_light_fault == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_bat_load_fuse_fault == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.bat_load_fuse_fault == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.phase_fault == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_unknown_1 == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.unknown_1 == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_unknown_2 == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.unknown_2 == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.conf_unknown_3 == 0 ? <img src="/img/gray.png" alt="" className="rms-img-size offline-tr" title="Not Configure" /> : site?.unknown_3 == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.is_overload == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>
                                        <td>
                                            {site?.is_load_disconnect == 1 ?
                                                <img src="/assets/icon/circle-red-png.webp" alt="" className="rms-img-size blink" title="Critical" />
                                                :
                                                <img src="/assets/icon/check_green_circle.png" alt="" className="rms-alarm-img" title="Normal" />
                                            }
                                        </td>



                                    </tr>
                                ))}

                            </tbody>
                        </table>
                   
                        {selector?.loading && <div className="text-center">Loading......</div>}
                    {/* <Paginate nextPage={nextPage} previousPage={previousPage} previousPageUrl={selector?.data.prv_page_url} nextPageUrl={selector?.data.next_page_url} postsPerPage={selector?.data.per_page} paginate={paginate} totalPosts={selector?.data.total_page} hasMorePage={selector?.data.has_more_page} onFirstPage={selector?.data.first_page} hasPage={selector?.data.has_page} currentPage={selector?.data.current_page} /> */}

                </div>
              
            </div>

        </>
    )
}